import { render, staticRenderFns } from "./CateTabs.vue?vue&type=template&id=18ba189f&scoped=true&"
import script from "./CateTabs.vue?vue&type=script&lang=ts&"
export * from "./CateTabs.vue?vue&type=script&lang=ts&"
import style0 from "./CateTabs.vue?vue&type=style&index=0&id=18ba189f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ba189f",
  null
  
)

export default component.exports